export const HIGHSCORES_LIST_SIZE = 4;
export const CHALLENGE_LIST_SIZE = 2;
